import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const empty = { code: "", type: "percentage", value: 10, min_order: 0, expiry: "", usage_limit: "", active: true };
const inp = "w-full border border-linen bg-white px-3 py-2.5 text-sm outline-none focus:border-pitch";

export default function AdminDiscounts() {
  const [discounts, setDiscounts] = useState([]);
  const [form, setForm] = useState(empty);
  const load = () => api.get("/admin/discounts").then((r) => setDiscounts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/discounts", { ...form, value: parseFloat(form.value), min_order: parseFloat(form.min_order) || 0,
        usage_limit: form.usage_limit ? parseInt(form.usage_limit) : null, expiry: form.expiry || null });
      toast.success("Discount created"); setForm(empty); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const toggle = async (d) => { try { await api.put(`/admin/discounts/${d.id}`, { ...d, active: !d.active }); load(); } catch {} };
  const del = async (id) => { try { await api.delete(`/admin/discounts/${id}`); toast.success("Deleted"); load(); } catch {} };

  return (
    <div className="max-w-4xl">
      <h1 className="font-serif text-3xl text-pitch mb-8">Discounts</h1>
      <form onSubmit={create} className="bg-white border border-linen p-6 mb-8 grid grid-cols-2 sm:grid-cols-3 gap-4">
        <input required placeholder="CODE" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className={inp} data-testid="discount-code" />
        <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className={inp}><option value="percentage">Percentage</option><option value="fixed">Fixed (AUD)</option></select>
        <input type="number" step="0.01" placeholder="Value" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} className={inp} data-testid="discount-value" />
        <input type="number" placeholder="Min order (AUD)" value={form.min_order} onChange={(e) => setForm({ ...form, min_order: e.target.value })} className={inp} />
        <input type="number" placeholder="Usage limit" value={form.usage_limit} onChange={(e) => setForm({ ...form, usage_limit: e.target.value })} className={inp} />
        <input type="date" value={form.expiry} onChange={(e) => setForm({ ...form, expiry: e.target.value })} className={inp} />
        <button type="submit" className="inline-flex items-center gap-2 bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.15em] px-6 py-3 w-fit" data-testid="discount-add"><Plus className="w-4 h-4" /> Add</button>
      </form>
      <div className="bg-white border border-linen divide-y divide-linen">
        {discounts.map((d) => (
          <div key={d.id} className="flex items-center gap-4 p-4 flex-wrap">
            <div className="font-mono text-sm tracking-wider flex-1">{d.code}
              <span className="text-stonemuted ml-3 font-sans text-xs">{d.type === "percentage" ? `${d.value}% off` : `$${d.value} off`}{d.min_order ? ` · min $${d.min_order}` : ""}{d.usage_limit ? ` · ${d.used_count || 0}/${d.usage_limit} used` : ""}</span>
            </div>
            <button onClick={() => toggle(d)} className={`text-[10px] font-mono uppercase tracking-widest px-3 py-1 ${d.active ? "bg-emeraldauth/10 text-emeraldauth" : "bg-stonemuted/20 text-stonemuted"}`}>{d.active ? "Active" : "Inactive"}</button>
            <button onClick={() => del(d.id)} className="p-2 text-stonemuted hover:text-vermilion"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {discounts.length === 0 && <div className="p-8 text-center text-stonemuted">No discount codes yet.</div>}
      </div>
    </div>
  );
}
